import { Box, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { formatSelectedRange } from "../../Helpers/dateDisplay";
import RangePeriodMode from "./RangePeriodMode";
import SinglePeriodMode from "./SinglePeriodMode";

const PERIOD_MODE = {
  SINGLE: "single",
  RANGE: "range",
};

export default function PeriodFilter({
  handleApplyFilters,
  currentPeriods,
  filters,
  isRTL,
  t,
}) {
  const [mode, setMode] = useState(filters.periodFrom ? PERIOD_MODE.RANGE : PERIOD_MODE.SINGLE);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [rangeStep, setRangeStep] = useState(null);
  const locale = isRTL ? "ar-EG" : "en-US";

  const handleSelectSinglePeriod = (value) => {
    setMode(PERIOD_MODE.SINGLE);
    handleApplyFilters({ period: value, periodFrom: "", periodTo: "" });
  };

  const handleSwitchToRange = () => {
    setMode(PERIOD_MODE.RANGE);
    setRangeStep("from");
    onOpen();
    handleApplyFilters({
      period: "",
      periodFrom: filters.periodFrom || "",
      periodTo: filters.periodTo || "",
    });
  };

  const handleRangeChange = (key, value) => {
    if (key === "periodFrom") {
      if (filters.periodTo && value && value > filters.periodTo) {
        handleApplyFilters({ period: "", periodFrom: filters.periodTo, periodTo: value });
        return;
      }

      handleApplyFilters({ period: "", periodFrom: value });
      return;
    }

    if (filters.periodFrom && value && value < filters.periodFrom) {
      handleApplyFilters({ period: "", periodFrom: value, periodTo: filters.periodFrom });
      return;
    }

    handleApplyFilters({ period: "", periodTo: value });
  };

  const displayLabel =
    formatSelectedRange(filters.periodFrom, filters.periodTo, locale) ||
    t("reports.selectRange", "نطاق مخصص");

  return (
    <Box h="full">
      {mode === PERIOD_MODE.SINGLE ? (
        <SinglePeriodMode
          currentPeriods={currentPeriods}
          currentValue={filters.period}
          isRTL={isRTL}
          onSelectPeriod={handleSelectSinglePeriod}
          onSwitchToRange={handleSwitchToRange}
          t={t}
        />
      ) : (
        <RangePeriodMode
          displayLabel={displayLabel}
          filters={filters}
          isOpen={isOpen}
          isRTL={isRTL}
          onChange={handleRangeChange}
          onClose={onClose}
          onOpen={onOpen}
          onSwitchToSingle={() => {
            setMode(PERIOD_MODE.SINGLE);
            onClose();
            handleApplyFilters({
              period: (filters.periodFrom || currentPeriods[0]?.value || "").slice(0, 7),
              periodFrom: "",
              periodTo: "",
            });
          }}
          rangeStep={rangeStep}
          setRangeStep={setRangeStep}
          t={t}
        />
      )}
    </Box>
  );
}
